export default function newsListingBlock() {
	const blocks = document.querySelectorAll('.news-listing-block');
	if (!blocks.length) return;

	/**
	 * Returns the active facet label without trailing count text like "(12)".
	 */
	function getCleanFacetLabel(block) {
		const checkedFacet = block.querySelector('.types-filter-tabs .facetwp-radio.checked');
		const rawLabel = checkedFacet ? checkedFacet.textContent.trim() : '';

		return rawLabel.replace(/\s*\(\d+\)\s*$/, '').trim();
	}

	function updateHeading(block) {
		const heading = block.querySelector('.js-news-listing-heading');
		if (!heading) return;

		const label = getCleanFacetLabel(block);
		heading.textContent = label && label !== 'Latest' ? `Latest ${label}` : 'Latest';
		heading.style.visibility = 'visible';
	}

	blocks.forEach((block) => {
		const heading = block.querySelector('.js-news-listing-heading');
		if (heading) {
			heading.style.visibility = 'hidden';
		}

		updateHeading(block);
	});

	document.addEventListener('facetwp-refresh', () => {
		blocks.forEach((block) => {
			const heading = block.querySelector('.js-news-listing-heading');
			if (heading) {
				heading.style.visibility = 'hidden';
			}
		});
	});

	document.addEventListener('facetwp-loaded', () => {
		blocks.forEach((block) => {
			updateHeading(block);
		});
	});
}
